import router from '../router/index'

const getinfo = function (infokey, isJSON = true) {
    let value = localStorage.getItem(infokey)
    if (value && value != 'undefined') {
        if (isJSON) {
            return JSON.parse(value);
        } else {
            return value;
        }
    } else if (infokey == 'userinfo' || infokey == 'universityId_dictText' || infokey == 'teacher_info') {
        console.log("获取localStorage" + infokey + "出错")
        router.push("/")
    } else {
        console.log("获取localStorage" + infokey + "出错")
    }

}
const setinfo = function (infokey, data) {
    localStorage.setItem(infokey, data)
}
export default { getinfo, setinfo }

export function isMobile() {
    return screen.width < 768;
}

export function isWX(){  
    var ua = navigator.userAgent.toLowerCase();  
    if(ua.match(/MicroMessenger/i)=="micromessenger") {  
        return true;//是微信打开  
    } else {  
        return false;//不是微信打开  
    }  
} 



// WEBPACK FOOTER //
// ./src/utils/index.js